import React from "react"

import FinderTaskModel from "../../../../model2/task/finder/finder-task-model"
import HintPopover from "../../../../../core/gd-ui/hint-popover/hint-popover"

// @ts-ignore
import TaskIcon from "../../../../../core/gd-components/icons/task-icon/task-icon"

type Props = {
    task                : FinderTaskModel

    isHighlighted       : boolean
    showParentProject   : boolean
    selected            : boolean
    noSubtasks?         : boolean

    onClickTask?        : func
}

type State = {
    expanded: boolean
}

const debug = false
// const debug = "FinderTask"

export default class FinderTask extends React.Component<Props, State> {

    constructor(props: Props) {
        super(props)

        this.state = {
            expanded: false
        }
    }

    click = () => {
        return this.onClickTask(this.props.task)
    }

    onClickTask = (task: FinderTaskModel, e?: any) => {
        if (e) { e.stopPropagation() }
        if (this.props.onClickTask) {
            return this.props.onClickTask(task)
        }
    }

    onToggleExpand = (e: any) => {
        e.stopPropagation()
        return this.setState({
            expanded: !this.state.expanded
        })
    }

    renderSingle(task: FinderTaskModel, showParentProject: boolean, subtasksCount?: number, handle?: React.ReactNode) {
        const classes = Classes("search-item task flex-row-left-center", {
            'is-highlighted': this.props.isHighlighted,
            selected        : this.props.selected
        })

        debug && console.log(debug, 'renderSingle', task)

        return (
            <div key       = {task.id}
                 className = {classes}
                 onClick   = {(e) => this.onClickTask(task, e)}
            >
                {handle}
                <TaskIcon
                    className   = "search-item-icon task-icon w-16"
                    icon        = {task.icon}
                />
                <div className="search-item-title flex-1 flex-row-left-center">
                    <div className="search-item-title-label">{task.title}</div>
                    {showParentProject &&
                        <div className="search-item-project">
                            <div className="project-label">{task.project?.name}</div>
                        </div>
                    }
                </div>
                {!!subtasksCount &&
                    <div className="subtasks-counter ui5-counter">
                        <div className="ui5-ico-12 i5-folder-tree"/>
                        <div className="m-l-5">{subtasksCount}</div>
                        <HintPopover hint="Subtasks"/>
                    </div>
                }
                <div className="search-item-short-id">#{task.shortId}</div>
            </div>
        )
    }

    renderWithSubtasks(task: FinderTaskModel, showParentProject: boolean) {
        const iconClasses = Classes("subtasks-icon", {
            "i5-group-closed" : !this.state.expanded,
            "i5-group-open"   : this.state.expanded,
            "expanded"        : this.state.expanded,
        })

        const handle = (
            <div className="handle" onClick={this.onToggleExpand}>
                <div className={iconClasses}/>
            </div>
        )

        return (
            <div className="search-item-container">
                {this.renderSingle(task, showParentProject, !this.state.expanded ? task.subtasks!.length : undefined, handle)}

                {this.state.expanded &&
                    <div className="subtasks-container">
                        {_.map(task.subtasks, (subtask: FinderTaskModel) =>
                            this.renderSingle(subtask, showParentProject)
                        )}
                    </div>
                }
            </div>
        )
    }

    render() {
        return !this.props.noSubtasks && this.props.task.subtasks
            ? this.renderWithSubtasks(this.props.task, this.props.showParentProject)
            : this.renderSingle(this.props.task, this.props.showParentProject)
    }
}
